<template>
  <div class="wrapper" :style="wrapperStyle">
    <router-view></router-view>
  </div>
</template>
<script>

export default {
  components: {},
  methods: {},
  computed: {
    wrapperStyle() {
      return {
        backgroundImage: `url('img/leaddist.png')`
      }
    }
  }
}

</script>
